import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import PrevArrowSVG from "../../components/SVG";
import NextArrowSVG from "../../components/SVG/NextArrowSVG";
import config from "../../config";
import makeRequest from "../../makeRequest";
import shapeImg from "../../assets/img/about/shape-2-1.png";
import fallbackImg from "../../assets/img/service/case-1-1.jpg";

function ServiceCard({ service }) {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    if (!service.hasImage) return;
    let objectUrl = null;
    let cancelled = false;
    fetch(`${config.api.baseUrl}/website/service/${service.id}/image`)
      .then((resp) => {
        if (!resp.ok) throw new Error();
        return resp.blob();
      })
      .then((blob) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(blob);
          setImgSrc(objectUrl);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [service.id, service.hasImage]);

  return (
    <div className="it-service-2-item item-style-3" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="it-service-2-thumb" style={{ height: "220px", overflow: "hidden", flexShrink: 0 }}>
        <img src={imgSrc || fallbackImg} alt={service.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
      <div className="it-service-2-content p-relative" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <h4 className="it-service-title mb-15">
          <Link className="hover-anim grey" to={`/service/${service.id}`}>
            {service.name}
          </Link>
        </h4>
        <p className="mb-20" style={{ flex: 1 }}>
          {service.description ? (service.description.length > 100 ? `${service.description.slice(0, 100)}…` : service.description) : "\u00a0"}
        </p>
        <Link className="it-btn-theme service-btn" to={`/service/${service.id}`}>
          <span>Learn More</span>
        </Link>
      </div>
    </div>
  );
}

const Cases = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    makeRequest({ route: "/website/service/public", method: "get" })
      .then((data) => setServices(data?.data || []))
      .catch(() => {});
  }, []);

  if (services.length === 0) return null;

  return (
    <div className="it-cases-area p-relative z-index fix pt-120 pb-120">
      {/* <div className="it-cases-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div> */}
      <div className="container">
        <div className="it-cases-title-wrap mb-70">
          <div className="row align-items-end">
            <div className="col-xl-8 col-lg-6 col-md-7">
              <div className="it-cases-left">
                <div>
                  <span className="mh-lf-section__eyebrow">
                    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M10 2a1 1 0 011 1v5h5a1 1 0 010 2h-5v5a1 1 0 01-2 0v-5H4a1 1 0 010-2h5V3a1 1 0 011-1z" />
                    </svg>
                    Trusted Medical Care
                  </span>
                  <h2 className="mh-lf-section__title" style={{ marginBottom: 0 }}>
                    Our Healthcare Services
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-5">
              <div className="it-cases-arrow-box text-md-end">
                <button className="slider-prev cases-prev">
                  <span>
                    <PrevArrowSVG />
                  </span>
                </button>
                <button className="slider-next cases-next">
                  <span>
                    <NextArrowSVG />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-cases-wrapper">
              <div className="swiper-container it-cases-active">
                <Swiper
                  modules={[Navigation]}
                  speed={900}
                  loop={services.length > 4}
                  slidesPerView={4}
                  spaceBetween={30}
                  navigation={{
                    prevEl: ".cases-prev",
                    nextEl: ".cases-next",
                  }}
                  breakpoints={{
                    1200: { slidesPerView: 4 },
                    992: { slidesPerView: 3 },
                    768: { slidesPerView: 2 },
                    0: { slidesPerView: 1 },
                  }}
                  style={{ "--swiper-wrapper-transition-timing-function": "ease-in-out" }}
                >
                  {services.map((service) => (
                    <SwiperSlide key={service.id} className="swiper-slide">
                      <ServiceCard service={service} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cases;
